module.exports = __webpack_public_path__ + "static/img/wx.0771a696.jpg";